<template>
  <MobileFriendlyRow
    :item="enterprise"
    :index="index"
    :cols="cols"
    table-name="enterprise"
  >
    <template #cell>
      <div class="td ent-id">
        <EnterpriseId :enterprise-id="enterprise.enterpriseId"/>
      </div>
    </template>
    <template #actions>
      <button type="button" data-tippy-content="edit" class="btn btn-primary btn-sm" @click="emit('edit', enterprise)"><font-awesome-icon icon="wrench"/></button>
      <button type="button" data-tippy-content="delete" class="btn btn-danger btn-sm" @click="emit('delete', enterprise)" :disabled="!canDelete"><font-awesome-icon icon="trash-alt"/></button>
    </template>
    <template #collapse-data>
      <div class="ps-2">

        <div class="header ">
          enrol profile
        </div>
        <div class="value text-monospace">
          {{getEnrolProfile(enterprise)}}
        </div>

        <div class="header">
          actility references
        </div>
        <div class="value">
          <div>supplierId: <span class="text-monospace">{{getSupplierId(enterprise)}}</span></div>
          <div>subscriberId: <span class="text-monospace">{{getSubscriberId(enterprise)}}</span></div>
        </div>

        <div class="header">
          data storage
        </div>
        <div class="value">
          <div v-if="!enterprise.dataStorage">
            <span class="disabled">storage: <font-awesome-icon icon="exclamation-circle" /> DISABLED</span>
          </div>
          <div v-else>
            <span class="enabled">storage: <font-awesome-icon icon="check-circle" /> ENABLED</span>
          </div>
          <div v-if="!enterprise.dataDecoding">
            <span class="disabled">decoding: <font-awesome-icon icon="exclamation-circle" /> DISABLED</span>
          </div>
          <div v-else>
            <span class="enabled">decoding: <font-awesome-icon icon="check-circle" /> ENABLED</span>
          </div>
        </div>

        <div class="header">
          group list
        </div>
        <div class="value text-monospace">
          <div v-for="groupName in enterprise.groupList" :key="groupName">
            {{groupName}}
          </div>
        </div>

        <div class="header">
          number of devices
        </div>
        <div class="value">
          <div>direct: <span class="text-monospace">{{enterprise.numDevices.direct}}</span></div>
          <div>all: <span class="text-monospace">{{enterprise.numDevices.all}}</span></div>
        </div>
      </div>
    </template>

    <template #error>
      <Error :label="error"/>
    </template>


  </MobileFriendlyRow>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import MobileFriendlyRow from "@/components/MobileFriendlyRow.vue";
import Error from '@/components/Error.vue';
import tippy from "tippy.js";
import EnterpriseId from '@/components/EnterpriseId.vue';
import { Column, Enterprise } from '@/types';

interface Props {
  enterprise: Enterprise;
  index: number;
}

const props = withDefaults(defineProps<Props>(), {
  enterprise: () => ({}) as Enterprise,
  index: 0
});

const emit = defineEmits<{
  edit: [enterprise: Enterprise];
  delete: [enterprise: Enterprise];
}>();

const cols: Column[] = [
  {colName: 'enterprise', colStyle:{'flex-grow':1}, colKey:'enterpriseId'}
];

const error = ref<string>('');

onMounted(async () => {
  // nothing here yet
  tippy('[data-tippy-content]');
});

const getEnrolProfile = (ent: Enterprise): string => {
  return ent.nwServer && ent.nwServer.actility && ent.nwServer.actility.enrolId ? ent.nwServer.actility.enrolId : 'default';
};

const getSubscriberId = (ent: Enterprise): string => {
  return ent.nwServer && ent.nwServer.actility && ent.nwServer.actility.subscriberId ? `${ent.nwServer.actility.subscriberId}` : 'n/a';
};

const getSupplierId = (ent: Enterprise): string => {
  return ent.nwServer && ent.nwServer.actility && ent.nwServer.actility.supplierId ? `${ent.nwServer.actility.supplierId}` : 'n/a';
};

const canDelete = computed<boolean>(() => {
  return props.enterprise.numDevices.direct === 0 && props.enterprise.numDevices.all === 0;
});

</script>

<style scoped lang="scss">
@use "@/variables.scss" as *;

.td {padding: 3px}


.header {
  text-align:left;
  color: $bgColour;
  font-weight: bold;
}

.value {
  text-align: left;
  margin-bottom: 0.5rem;
}

.api-key-descriptiom {
  opacity: 0.5;
  font-size: 0.8rem
}

.disabled {
  color:red;
}

.enabled {
  color: green;
}

</style>